import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

axios.defaults.baseURL = 'http://localhost:1414'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newFault: {
      fault: {
        description_concise: null,
        description_full: null,
        customer_id: null,
        location_id: null,
        asset_id: null,
        reported: new Date().toISOString(),
        report_method: 4,
        priority: 2
      },
      notify_sms: null,
      notify_email: null
    },
    registerDetail: {
      uuid: null,
      lookup_code: null,
      base_url: null
    },
    inboundDetail: {
      uuid: null,
      customer_id: null,
      customer_name: null,
      location_id: null,
      location_name: null,
      asset_id: null,
      asset_name: null
    }
  },
  mutations: {
    SET_REGISTER_DETAIL (state, val) {
      state.registerDetail = val
    },
    SET_INBOUND_DETAIL (state, val) {
      state.inboundDetail = val
    },
    UPDATE_NEWFAULT_DESCRIPTION_CONCISE (state, val) {
      state.newFault.fault.description_concise = val
    },
    UPDATE_NEWFAULT_DESCRIPTION_FULL (state, val) {
      state.newFault.fault.description_full = val
    },
    UPDATE_NEWFAULT_CUSTOMER_ID (state, val) {
      state.newFault.fault.customer_id = val
    },
    UPDATE_NEWFAULT_LOCATION_ID (state, val) {
      state.newFault.fault.location_id = val
    },
    UPDATE_NEWFAULT_ASSET_ID (state, val) {
      state.newFault.fault.asset_id = val
    },
    UPDATE_NEWFAULT_NOTIFY_SMS (state, val) {
      state.newFault.notify_sms = parseInt(val)
    },
    UPDATE_NEWFAULT_NOTIFY_EMAIL (state, val) {
      state.newFault.notify_email = val
    }
  },
  actions: {
    getRegisterByCode ({ commit }, code) {
      return axios.get(`/register?code=${code}`)
        .then(r => {
          commit('SET_REGISTER_DETAIL', r.data)
        })
    },
    getInboundDetail ({ state, commit }) {
      return axios.get(`http://${state.registerDetail.base_url}/inbounds/${state.registerDetail.uuid}`)
        .then(r => {
          console.log(r)
          commit('SET_INBOUND_DETAIL', r.data)
        })
        .then(() => {
          commit('UPDATE_NEWFAULT_CUSTOMER_ID', state.inboundDetail.customer_id)
          commit('UPDATE_NEWFAULT_LOCATION_ID', state.inboundDetail.location_id)
          commit('UPDATE_NEWFAULT_ASSET_ID', state.inboundDetail.asset_id)
        })
    },
    submitFault ({ state }) {
      return axios.post(`http://${state.registerDetail.base_url}/faults/inbound?uuid=${state.registerDetail.uuid}`, state.newFault)
    }

  }
})
